import React, { Component } from "react";
import "./Components/style.css";

class TermsOfUse extends Component {
  render() {
    return (
      <section className="contentWrapper">
        <h1>Casemasters Terms of Service</h1>
        <p>
          Casemasters, Inc., (“Casemasters”/“us”/“we”), provides a messaging and communications service called
          “Casemasters” through our website (the “Site”) and our application for mobile devices, tablet computers and
          similar devices (the “App”) and provide access to Collective Content (defined below), collectively the Site,
          App and Collective Content and services is referred to herein as the “Services”). Please read carefully the
          following terms and conditions (“Terms”) and our{" "}
          <a href="https://www.casemasters.com/sections/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>.
        </p>
        <p>
          BY CLICKING ON THE “AGREE” OR “I ACCEPT” BUTTON, OR ACCESSING OR USING THE SERVICES INCLUDING BY DOWNLOADING
          OR POSTING ANY CONTENT FROM OR THROUGH THE SERVICES, YOU ARE INDICATING THAT YOU HAVE READ, UNDERSTAND AND
          AGREE TO BE BOUND BY, THESE TERMS WHICH CONSTITUTE A BINDING LEGAL AGREEMENT BETWEEN YOU AND Casemasters, INC.
          YOU HAVE NO RIGHT TO ACCESS OR USE THE SERVICES OR COLLECTIVE CONTENT UNLESS YOU AGREE TO THESE TERMS. If you
          accept or agree to these Terms on behalf of a company or other legal entity, you represent and warrant that
          you have the authority to bind that company or other legal entity to these Terms and, in such event, “you” and
          “your” extends beyond you to also refer and apply to that company or other legal entity.
        </p>
        <h2>1. KEY CONTENT-RELATED TERMS</h2>
        <p>
          “Content” means text, graphics, images, software (excluding the App) information, messages or other materials.
        </p>
        <p>
          “Collective Content” means, collectively, Casemasters Content and Registered User Content. Certain areas of
          the Site and App (and your access to or use of certain Collective Content) may have different terms and
          conditions posted or may require you to agree with and accept additional terms and conditions. If there is a
          conflict between these Terms and terms and conditions posted for a specific area of the Site, Services, App or
          Collective Content, the latter terms and conditions will take precedence with respect to your use of or access
          to that area of the Site, Services, App or Collective Content. Unless explicitly stated otherwise, any new
          features that augment or enhance the current Services in future shall be subject to these Terms; they will be
          posted to the Site as available as well as to the App and you are deemed to have accepted them.
        </p>
        <p>
          “Direct Messaging” means Casemasters’s direct messaging feature which allows one Registered User to
          communicate directly with another Registered User.
        </p>
        <p>
          “Casemasters Content” means Content that we make available through the Services including any Content licensed
          from a third party, but excluding Registered User Content.
        </p>
        <p>
          “Registered User” and “you” means a person that completes Casemasters’s account registration process, as
          described in the “Account Registration” section below.
        </p>
        <p>
          “Registered User Content” means Content a Registered User posts, uploads, publishes, submits, or transmits to
          be made available through the Services.
        </p>
        <p>
          “Verified User” means a Registered User who has been verified to be a licensed healthcare professional or
          student in a recognized healthcare program. Casemasters has the discretion to verify inactive or retired
          healthcare professionals.
        </p>
        <h2>2. MODIFICATIONS</h2>
        <p>
          Casemasters, Inc. reserves the right, at its sole discretion, to modify, discontinue or terminate the Services
          (or any aspect thereof) or to modify these Terms, at any time and without prior notice. If we modify these
          Terms we will post the modification via the Site or App or provide you with notice of the modification. By
          continuing to access or use the Services after we have posted a modification or have provided you with notice
          of a modification, you agree to be bound by the modified Terms. If the modified Terms are not acceptable to
          you, you agree to immediately stop using the Services.
        </p>
        <h2>3. ACCOUNT REGISTRATION; CONDITIONS ON ACCESS AND USE OF SERVICES</h2>
        <h3>3.1 AVAILABILITY.</h3>
        <p>
          Access to and use of the Services is limited to individuals who are at least 18 years of age. The Services are
          available worldwide but currently not for the following countries: Cuba, Syria, Sudan, Libya, Iran, and North
          Korea. Special terms apply to Users in different jurisdictions so please refer to Appendix A for terms which
          may apply to your use and rights under this Agreement.
        </p>
        <h3>3.2 COMPLIANCE WITH LAWS.</h3>
        <p>
          You are responsible for ensuring that your use of the Services complies with the laws of your country of
          residence and you assume the risks (including indemnity under Section 13) attendant to the use of the Services
          and the use of any materials that you provide. You must register to create an account (“Account”) and become a
          “Registered User” to use the Services.
        </p>
        <h3>3.3 REGISTRATION.</h3>
        <p>
          To register, you must provide a username, your email address, your medical specialty, and other information
          specified in the registration form (“Registration Data”). You represent and warrant: (i) the Registration Data
          that you provide about yourself is true, accurate, current, and complete; (ii) you are at least 18 years of
          age; and (iii) you will maintain and promptly update the Registration Data to keep it at all times true,
          accurate, current, and complete. You authorize Casemasters, Inc, in its sole discretion to confirm the
          truthfulness and accuracy of the Registration Data. If you provide any information that is untrue, inaccurate,
          not current or incomplete, or if Casemasters, Inc. has reasonable grounds to suspect that such information is
          untrue, inaccurate, not current or incomplete, Casemasters, Inc. has the right to suspend or terminate your
          Account and refuse any and all current or future use of the Services. You also authorize Casemasters, Inc. to
          access your contact list and/or address book on your device at your direction in order to allow you to share
          information and images with specific contacts you choose, connect with your colleagues, or to allow you to
          invite specific contacts you choose to use the Services. If your invitee is a resident of any country that has
          anti-spam laws or privacy laws requiring consent from users in place, including but not limited to Argentina,
          Australia, Belarus, Brazil, Chile, Costa Rica, Iceland, Ireland, Israel, Japan, Mexico, New Zealand, Norway,
          Peru, South Africa, Turkey, the United Kingdom, Venezuela or any part of the European Economic Area, you must
          obtain his or her prior consent to use his or her e-mail address to share information or images or issue an
          invitation to use the Services.
        </p>
        <p>
          Use of the Services is void where prohibited by law or otherwise. By using the Services, you represent and
          warrant that you have the right, authority, and capacity to agree to and abide by these Terms and that you are
          not prohibited from using the Services. You understand that your use of the Services may involve or require
          the transmission of significant amounts of data. You are solely responsible for all data charges that may be
          charged by your wireless carrier or internet service provider or that may otherwise arise from your use of the
          Services.
        </p>
        <p>
          You understand and agree that the Services may include certain communications from Casemasters, Inc., such as
          service announcements and administrative messages, and that while these communications are considered part of
          Casemasters membership, you will be able to opt out of receiving them. However, you will not be able to opt
          out of any announcements and messages related to the implementation of Casemasters’s{" "}
          <a href="https://www.casemasters.com/sections/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{" "}
          and your obligations thereunder with regard to your Registered User Content.
        </p>
        <h3>3.4 SUBSCRIPTION/USAGE FEES.</h3>
        <p>
          Casemasters, Inc. does not currently charge fees for the use of the Services. However, you acknowledge and
          agree that Casemasters, Inc. reserves the right, in its sole discretion, to charge you for and collect fees
          from you for the use of the Services and to send and receive communications. Casemasters, Inc. will provide
          notice of any fee collection via the Services prior to implementing such a fee, and you will have a choice at
          that time to continue to use the Services or not. If you choose not to pay, Casemasters, Inc. reserves the
          right to immediately terminate your access to the Services.
        </p>
        <h2>4. SECURITY</h2>
        <p>
          The Services are designed to require users to provide a valid, working e-mail address and password to access
          and use the Site, Services, App, and Collective Content. Upon registering, you will select a password. Your
          email address and the password and codes assigned to you are, collectively, your “User Information.” You are
          solely responsible for (1) maintaining the strict confidentiality of your User Information, (2) not allowing
          another person to use your User Information to access the Services, (3) any and all damages or losses that may
          be incurred or suffered as a result of any activities that occur under your User Information. You agree to
          immediately notify Casemasters, Inc. in writing by email of any unauthorized use of your User Information or
          any other breach of security. Casemasters, Inc. is not and shall not be liable for any harm arising from or
          relating to the theft of your User Information, your disclosure of your User Information, or the use of your
          User Information by another person or entity. Any attempt to obtain unauthorized access or to exceed
          authorized access to the Site, Services, App, or Collective Content shall be considered a trespass and
          computer fraud and abuse, punishable under national, provincial, state, and federal laws. Casemasters, Inc.
          hereby notifies you that any or all communications with this Site can and will be monitored, captured, and
          recorded and the communications may be transmitted to the authorities as deemed necessary by Casemasters, Inc.
          in its sole discretion and without further notice.
        </p>
        <h2>5. DISCLAIMERS</h2>
        <h3>5.1 NO DIAGNOSTIC SERVICE.</h3>
        <p>
          Casemasters IS PRIMARILY AN EDUCATIONAL TOOL AND IS NOT INTENDED TO SERVE THE FOLLOWING NEEDS: AS A DIAGNOSTIC
          SERVICE; AS A CONFIRMATORY SERVICE TO PROVIDE CERTAINTY IN DIAGNOSIS; TO SELECT, GUIDE, OR PROMOTE THERAPY OF
          MEDICAL CONDITIONS; FOR USE IN HAZARDOUS OR MISSION-CRITICAL CIRCUMSTANCES OR FOR USES REQUIRING FAIL-SAFE
          PERFORMANCE; OR IN SITUATIONS WHERE FAILURE COULD LEAD TO DEATH OR PERSONAL INJURY (COLLECTIVELY,
          “UNAUTHORIZED PURPOSES”). BECAUSE Casemasters HAS NOT BEEN DESIGNED, INTENDED, OR AUTHORIZED FOR SUCH
          UNAUTHORIZED PURPOSES, YOU SHALL NOT USE THE SITE, SERVICES, OR APP FOR SUCH PURPOSES OR UNDER SUCH
          CIRCUMSTANCES. YOU FURTHER ACKNOWLEDGE THAT THE USE OF Casemasters’S SITE, SERVICES, AND APP FOR SUCH
          UNAUTHORIZED PURPOSES MAY CONSTITUTE A VIOLATION OF LAWS APPLICABLE TO THE PRACTICE OF MEDICINE OR OTHER
          HEALTH PROFESSION(S).
        </p>
        <h3>5.2 NO WARRANTY.</h3>
        <p>
          YOUR RELIANCE UPON THE CONTENT OBTAINED OR USED BY YOU THROUGH THE SITE, SERVICES, OR APP IS SOLELY AT YOUR
          OWN RISK.
        </p>
        <h3>5.3 DIRECT MESSAGING FEATURE; NO MEDICAL SERVICES.</h3>
        <p>
          Casemasters’S DIRECT MESSAGING FEATURE ARE TO BE USED SOLELY TO OBTAIN FEEDBACK, FOR EDUCATION AND FOR
          DISCUSSION. NEITHER THE USER SENDING THE DIRECT MESSAGE NOR THE USER RESPONDING TO THE PAGE OR DIRECT MESSAGE
          ARE INTENDING TO OR ARE PROVIDING MEDICAL SERVICES BY DOING SO. A USER USING THE PAGING FEATURE OR DIRECT
          MESSAGING FEATURE IS NOT REQUESTING AND SHALL NOT REQUEST A MEDICAL CONSULTATION OF ANY KIND; YOU ARE SOLELY
          REQUESTING FEEDBACK, EDUCATION, AND DISCUSSION. YOU ACKNOWLEDGE THAT YOU ARE NOT ENGAGING IN THE PRACTICE OF
          MEDICINE NOR REQUESTING MEDICAL SERVICES OF ANY KIND OR INTENDING TO CREATE ANY KIND OF PHYSICIAN/PATIENT
          RELATIONSHIP BY USING THE PAGING FEATURE OR DIRECT MESSAGING FEATURE AND BY RESPONDING TO OR ENGAGING IN ANY
          KIND OF CONVERSATION RELATED TO A PAGE OR DIRECT MESSAGE. A USER RESPONDING TO A PAGE OR DIRECT MESSAGE IS NOT
          GIVING AND SHALL NOT GIVE MEDICAL ADVICE OF ANY KIND. YOU ACKNOWLEDGE THAT BY RESPONDING TO ANOTHER USER’S
          DIRECT MESSAGE AND PROVIDING INFORMATION, YOU, AS A SPECIALIST OR OTHER REGISTERED USER, ARE NOT AND SHALL NOT
          PROVIDE MEDICAL SERVICES, ENGAGE IN THE PRACTICE OF MEDICINE OR CREATE OR INTEND TO CREATE A PHYSICIAN/PATIENT
          RELATIONSHIP OR TO ACT AS A MEDICAL CONSULTANT.
        </p>
        <h2>6. PRIVACY & CONTENT TERMS</h2>
        <h3>6.1 PRIVACY POLICY.</h3>
        <p>
          See our{" "}
          <a href="https://www.casemasters.com/sections/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>{" "}
          for information and notices concerning Casemasters, Inc.’s collection and use of your personal information. By
          clicking on the “Agree” or “I Accept” button, or accessing or using the Site, Services, or App you acknowledge
          and agree to the provisions of the Privacy Policy and affirm that the Privacy Policy forms a part of these
          Terms.
        </p>
        <h3>6.2 FEEDBACK.</h3>
        <p>
          We welcome and encourage you to provide feedback, comments, and suggestions for improvements to the Site,
          Services, or App (“Feedback”). You may submit Feedback by emailing us. You acknowledge and agree that if you
          submit any Feedback to us, you hereby grant to us a non-exclusive, worldwide, perpetual, irrevocable,
          fully-paid, royalty-free, sub-licensable (through several tiers) and transferable license under any and all
          intellectual property rights that you own or control in relation to the Feedback to use, reproduce, view,
          communicate to the public by any means, print, copy (whether onto hard disk or other media), edit, translate,
          perform and display (publicly or otherwise), distribute, redistribute, modify, adapt, make, sell, offer to
          sell, transmit, license, transfer, stream, broadcast, create derivative works from, and otherwise use and
          exploit the Feedback for any purpose.
        </p>
        <h3>6.3 USER CONTENT TERMS.</h3>
        <p>
          All content generated by a Registered User including all message data transmitted using Direct Messaging, must
          comply with local, national, provincial, state, and federal privacy legislation and best practices.
          Identifying information must be removed from Registered User Content. ‘. In addition, you must refer to the{" "}
          <a href="https://www.casemasters.com/sections/content-policy" target="_blank" rel="noopener noreferrer">
            Content Policy available here
          </a>{" "}
          and you represent and warrant that each time you submit content you have complied with the terms therein on
          what identifying information should be removed from images of people.
        </p>
        <h3>6.4 OWNERSHIP OF CONTENT.</h3>
        <p>
          Casemasters, Inc. does not claim ownership of any Content that you post on or through the Service. Instead,
          you hereby grant to Casemasters, Inc., in perpetuity, a non-exclusive, fully paid and royalty-free,
          transferable, sub-licensable (through several tiers), worldwide license to use, reproduce, view, communicate
          to the public by any means, print, copy, (whether onto hard disk or other media), edit, translate, perform,
          and display (publicly or otherwise), redistribute, modify, adapt, make, sell, offer to sell, transmit,
          distribute, license, transfer, stream, broadcast, create derivative works from, and otherwise use and exploit
          the Content that you post on or through the Service, subject to the Service's Privacy Policy.
        </p>
        <p>
          If you submit content to Casemasters, you are authorizing Casemasters to act as your agent to issue take-down
          notices under the Digital Millennium Copyright Act (the “DMCA”) and/or any other similar legislation that
          allows the submission of requests to Internet Service Providers for the purpose of removing infringing or
          allegedly infringing materials. You will be responsible for monitoring and enforcing your copyright. If
          Casemasters does become aware of infringement, then Casemasters, at its sole discretion, may elect to issue
          take-down notices under the DMCA or similar legislation.
        </p>
        <h3>6.5 USER CONTENT WARRANTIES.</h3>
        <p>
          You acknowledge and agree that you are solely responsible for all Registered User Content that you make
          available through the Site, Services, or App. Accordingly, you represent and warrant that: (i) you either are
          the sole and exclusive owner of all Registered User Content that you make available through the Site,
          Services, or App or you have all rights, licenses, consents and releases that are necessary to grant to
          Casemasters, Inc. the rights in such Registered User Content, as contemplated under these Terms; and (ii)
          neither the Registered User Content nor your posting, uploading, publication, submission, or transmittal of
          the Registered User Content or Casemasters, Inc.’s use of the Registered User Content (or any portion thereof)
          on, through or by means of the Site, Services, or App will (a) infringe, misappropriate, or violate a third
          party’s patent, copyright, trademark, trade secret, moral rights, or other intellectual property rights, or
          rights of publicity or privacy, or (b) result in the violation of any applicable law or regulation, including,
          but not limited to any applicable laws, rules, or regulations relating to personal health information,
          personal information and privacy, the Health Insurance Portability and Accountability Act (HIPAA), the
          Personal Information Protection and Electronic Documents Act (PIPEDA), the Personal Health Information
          Protection Act (PHIPA), the Health Information Technology for Economic and Clinical Health (HITECH) Act, the
          Data Protection Act 1998, the Protection of Personal Information Act 2013, the Data Protection Act of 1978,
          the Spanish Data Protection Act 15/1999, the Belgian Act of 08 December 1992, Law 2472/1997 on the Protection
          of the Individual from the Processing of Personal Data, the Indian Information Technology Act, 2000, the
          Argentine Personal Data Protection Act N°25.326, Act N°26.529 and Intellectual Property Act N°11.723, Act on
          the Protection of Personal Information of Japan, the Dubai Healthcare City Health Data Protection Regulation
          No. (7) of 2013 (as amended) and the Dubai International Financial Centre Data Protection Law No.1 of 2007 (as
          amended) and the DIFC Data Protection Regulations 2007 (as amended), Personal Information Protection Act, and
          Act on Promotion of Information Communications Network Utilization and Information Protection of Korea, Law of
          the Republic of Kazakhstan On Personal Data and its Protection from 21 May 2013 No. 94-V, the Federal Law of
          the Russian Federation “On Personal Data”, the Federal law of the Russian Federation “On the Fundamentals of
          Health Protection in the Russian Federation” , Act On Personal Data Protection of Ukraine of 01 June 2010 (as
          amended) and any other applicable National, Provincial, State, and Federal privacy laws (collectively, the
          “Privacy Laws”) depending on your country or jurisdiction of access to the App. You retain the sole
          responsibility of your individual compliance with applicable laws.
        </p>
        <h3>6.6 ADS.</h3>
        <p>
          You acknowledge and agree that some of the Site, Services, or App may be supported by advertising revenue and
          may contain advertisements or promotions. If you elect to have any personal, professional or business dealings
          with anyone whose products or services may be advertised on the Site, Services, or App, you acknowledge and
          agree that such dealings are solely between you and such advertiser and you further acknowledge and agree that
          Casemasters shall not have any responsibility or liability for any losses or damages that you may incur as a
          result of such dealings.
        </p>
        <p>Your representations, warranties, and obligations in this section survive termination of these Terms.</p>
        <h2>7. LICENSE TERMS</h2>
        <h3>7.1 Casemasters CONTENT LICENSE GRANT.</h3>
        <p>
          Subject to your compliance with the terms and conditions of these Terms, Casemasters, Inc. grants you a
          limited, non-exclusive, non-transferable license: (i) to view any Casemasters Content solely for your personal
          and non-commercial purposes; and (ii) to view any Registered User Content to which you are permitted access
          solely for your personal and non-commercial purposes. You have no right to sublicense the license rights
          granted in this section.
        </p>
        <h3>7.2 Casemasters CONTENT LICENSE RESTRICTIONS.</h3>
        <p>
          You will not use, copy, adapt, modify, prepare derivative works based upon, distribute, license, sell,
          transfer, publicly display, publicly perform, transmit, stream, broadcast or otherwise exploit the Site,
          Services, App or Collective Content, except as expressly permitted in these Terms or expressly permitted by
          applicable copyright laws. No licenses or rights are granted to you by implication or otherwise under any
          intellectual property rights owned or controlled by Casemasters, Inc. or its licensors, except for the
          licenses and rights expressly granted in these Terms.
        </p>
        <h3>7.3 USER CONTENT LICENSE.</h3>
        <p>
          We may, in our sole discretion, permit Registered Users to post, upload, publish, submit, or transmit
          Registered User Content. By making available any Registered User Content on or through the Site, Services, or
          App, you hereby grant to Casemasters, Inc. a worldwide, irrevocable, perpetual, non-exclusive, transferable,
          royalty-free license, with the right to sublicense (through several tiers), to use, reproduce, view,
          communicate to the public by any means, print, copy (whether onto hard disk or other media), edit, translate,
          perform and display (publicly or otherwise), distribute, redistribute, modify, adapt, make, sell, offer to
          sell, transmit, license, transfer, stream, broadcast, create derivative works from, and otherwise use and
          exploit such Registered User Content only on, through or by means of the Site, Services or App or by
          sublicense to partner or affiliate publications. Casemasters, Inc. does not claim any ownership rights in any
          Registered User Content and nothing in these Terms will be deemed to restrict any rights that you may have to
          use and exploit any Registered User Content.
        </p>
        <h3>7.4 APP LICENSE.</h3>
        <p>
          Subject to your compliance with these Terms, Casemasters, Inc. grants you a limited non-exclusive,
          non-transferable license to download and install a copy of the App on your mobile devices and/or computer that
          you own or control and to run such copies of the App solely for your own personal and professional use. The
          non-transferable license is also limited by any terms of service provisions required by the vendor from whom
          you purchased the Casemasters App (e.g., Apple iTunes, Google Play, etc.) (hereinafter, “App Vendor”).
        </p>
        <h2>8. PATIENT DATA AND LEGAL COMPLIANCE</h2>
        <h3>8.1 LEGAL OBLIGATIONS.</h3>
        <p>
          National, Provincial, State, and Federal laws, as well as ethical and licensure requirements of your
          profession and health regulatory college and licensing requirements impose obligations with respect to
          protection of privacy and patient confidentiality that may limit the ability of physicians, healthcare
          providers, and persons acting on their behalf, to make use of certain confidential patient information
          (“Patient Information”) and/or to transmit Patient Information to third parties without express consent.
        </p>
        <h3>8.2 COMPLIANCE REPRESENTATIONS AND WARRANTIES.</h3>
        <p>
          You represent and warrant that you will, at all times, comply with all laws directly or indirectly applicable
          to you that may now or hereafter govern the gathering, use, transmission, processing, receipt, reporting,
          disclosure, maintenance, and storage of Patient Information, and require all persons or entities under your
          direction or control to comply with such laws, including the Privacy Laws and the Privacy Policy. You are at
          all times solely responsible for obtaining and maintaining all patient consents, if applicable, and all other
          legally necessary consents or permissions required or advisable to disclose, process, retrieve, transmit, and
          view the Patient Information that you transmit, store, or receive in connection with the Site, Services, App,
          and any third party site.
        </p>
        <h3>8.3 Casemasters DISCLAIMER ON PATIENT INFORMATION.</h3>
        <p>
          We expressly do not assume any responsibility for your use or misuse of patient information or other
          information, whether intentional or inadvertent, that is transmitted, monitored, stored or received while
          using the Site, Services, App or Collective Content. We reserve the right to amend or delete any Collective
          Content (along with the right to revoke any membership or restrict access to the Site, Services, App or
          Collective Content) that we determine in our sole discretion violates the above. We further do not assume any
          responsibility to make any determinations regarding your subsequent reporting or notification obligations
          arising from any use or misuse of patient information or other information; these determinations and your
          actions in response to such determinations remain your sole responsibility.
        </p>
        <p>Your representations, warranties, and obligations in this section survive termination of these Terms.</p>
        <h2>9. GENERAL PROHIBITIONS</h2>
        <p>You agree not to do any of the following:</p>
        <ul>
          <li>
            <span>
              Post, upload, publish, submit, or transmit or otherwise make available any Content that you do not have a
              right to make available under any law or under contractual or fiduciary relationships;
            </span>
          </li>
          <li>
            <span>
              Take, post, upload, publish, transmit, or otherwise make use of any screen shots, screen captures,
              reproductions, drawings, photos, videos, downloads, or data of any of the images, comments, or
              contributions to Casemasters or any Collective Content;
            </span>
          </li>
          <li>
            <span>
              Post, upload, publish, submit or transmit any Content that: (i) infringes, misappropriates or violates a
              third party’s patent, copyright, trademark, trade secret, moral rights or other intellectual property
              rights, or rights of publicity or privacy; (ii) violates, or encourages any conduct that would violate,
              any applicable law or regulation or would give rise to civil liability; (iii) is fraudulent, false,
              misleading, or deceptive; (iv) is defamatory, obscene, pornographic, vulgar, or offensive; (v) promotes
              discrimination, bigotry, racism, hatred, harassment, or harm against any individual or group; (vi) is
              violent or threatening or promotes violence or actions that are threatening to any person or entity; or
              (vii) promotes illegal or harmful activities or substances;
            </span>
          </li>
          <li>
            <span>
              Use, display, mirror or frame the Site or App, or any individual element within the Site, Services or App,
              Casemasters, Inc. or Casemasters’s names, any Casemasters, Inc. trademark, logo, or other proprietary
              information, or the layout and design of any page or form contained on a page, without Casemasters, Inc.’s
              express written consent;
            </span>
          </li>
          <li>
            <span>
              Access, tamper with, or use non-public areas of the Site or App, Casemasters, Inc.’s computer systems, or
              the technical delivery systems of Casemasters, Inc.’s providers;
            </span>
          </li>
          <li>
            <span>
              Attempt to probe, scan, or test the vulnerability of any Casemasters, Inc. system or network or breach any
              security or authentication measures;
            </span>
          </li>
          <li>
            <span>
              Avoid, bypass, remove, deactivate, impair, descramble, or otherwise circumvent any technological measure
              implemented by Casemasters, Inc. or any of Casemasters, Inc.’s providers or any other third party
              (including another user) to protect the Site, Services, App, or Collective Content;
            </span>
          </li>
          <li>
            <span>
              Attempt to access or search the Site, Services, App, or Collective Content or download Collective Content
              from the Site, Services, or App through the use of any engine, software, tool, agent, device, or mechanism
              (including scripts, bots, spiders, scrapers, crawlers, data mining tools or the like) other than the
              software and/or search agents provided by Casemasters, Inc. or other generally available third party web
              browsers;
            </span>
          </li>
          <li>
            <span>
              Send any unsolicited or unauthorized advertising, promotional materials, email, junk mail, spam, chain
              letters, or other form of solicitation, from the App or otherwise;
            </span>
          </li>
          <li>
            <span>
              Use any meta tags or other hidden text or metadata utilizing a Casemasters, Inc. trademark, logo URL, or
              product name without Casemasters, Inc.’s express written consent;
            </span>
          </li>
          <li>
            <span>
              Use the Site, Services, App, or Collective Content for any commercial purpose or the benefit of any third
              party or in any manner not permitted by these Terms;
            </span>
          </li>
          <li>
            <span>
              Forge any TCP/IP packet header or any part of the header information in any email or newsgroup posting, or
              in any way use the Site, Services, App or Collective Content to send altered, deceptive, or false
              source-identifying information;
            </span>
          </li>
          <li>
            <span>
              Attempt to decipher, decompile, disassemble, or reverse engineer any of the software used to provide the
              Site, Services, App, or Collective Content;
            </span>
          </li>
          <li>
            <span>
              Interfere with, or attempt to interfere with, the access of any user, host or network, including, without
              limitation, sending a virus, overloading, flooding, spamming, or mail-bombing the Site, Services, or App;
            </span>
          </li>
          <li>
            <span>
              Collect or store any personally identifiable information from the Site, Services, or App from other users
              of the Site, Services, or App without their express permission;
            </span>
          </li>
          <li>
            <span>Impersonate or misrepresent your affiliation with any person or entity;</span>
          </li>
          <li>
            <span>Violate any applicable law or regulation, or any other rules of professional conduct; or</span>
          </li>
          <li>
            <span>Encourage or enable any other individual to do any of the foregoing.</span>
          </li>
        </ul>
        <p>
          Casemasters, Inc. will have the right to investigate and prosecute violations of any of the above to the
          fullest extent of the law. Casemasters, Inc. may involve and cooperate with law enforcement authorities in
          prosecuting users who violate these Terms. You acknowledge that Casemasters, Inc. has no obligation to monitor
          your access to or use of the Site, Services, App, or Collective Content or to review or edit any Collective
          Content, but has the right to do so for the purpose of operating the Site, Services, and App, to ensure your
          compliance with these Terms and the Privacy Policy, or to comply with applicable law or the order or
          requirement of a court, administrative agency or other governmental body having jurisdiction. Casemasters,
          Inc. reserves the right, at any time and without prior notice, to remove or disable access to any Collective
          Content that Casemasters, Inc., at its sole discretion, considers to be in violation of these Terms, the
          Privacy Policy, or otherwise harmful to the Site, Services, or App.
        </p>
        <h2>10. LINKS</h2>
        <p>
          The Site, Services, or App may contain links to third-party websites or resources, which do not form part of
          the Site, Services, or App. You acknowledge and agree that Casemasters, Inc. is not responsible or liable for:
          (i) the availability or accuracy of such websites or resources; or (ii) the Content, products, or services on
          or available from such websites or resources for which such third party is solely responsible. Links to such
          websites or resources do not imply any endorsement by Casemasters, Inc. of such websites or resources or the
          content, products, or services available from such websites or resources. You acknowledge sole responsibility
          for and assume all risk arising from your use of any such websites or resources or the Content, products, or
          services on or available from such websites or resources.
        </p>
        <h2>11. TERMINATION AND ACCOUNT CANCELLATION</h2>
        <p>
          If you breach any of these Terms, Casemasters, Inc. will have the right to suspend or disable your Account or
          terminate these Terms, at its sole discretion and without prior notice to you. Casemasters, Inc. reserves the
          right to revoke your access to and use of the Site, Services, App, and Collective Content at any time, with or
          without cause. You may cancel your Account at any time by contacting us. The change will be processed within
          seven (7) days.
        </p>
        <h2>12. DISCLAIMERS</h2>
        <p>
          THE SITE, SERVICES, APP, AND COLLECTIVE CONTENT ARE PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EITHER
          EXPRESS OR IMPLIED. WITHOUT LIMITING THE FOREGOING, Casemasters, INC. EXPLICITLY DISCLAIMS ANY WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT, AND ANY WARRANTIES
          ARISING OUT OF THE COURSE OF DEALING OR USAGE OF TRADE. Casemasters, INC. MAKES NO WARRANTY THAT THE SITE,
          SERVICES, APP, OR COLLECTIVE CONTENT WILL MEET YOUR REQUIREMENTS OR BE AVAILABLE ON AN UNINTERRUPTED, SECURE,
          OR ERROR-FREE BASIS. Casemasters, INC. MAKES NO WARRANTY REGARDING THE QUALITY OF ANY PRODUCTS, SERVICES, OR
          COLLECTIVE CONTENT PURCHASED OR OBTAINED THROUGH THE SITE, SERVICES, OR APP OR THE ACCURACY, TIMELINESS,
          TRUTHFULNESS, COMPLETENESS, OR RELIABILITY OF ANY CONTENT OBTAINED THROUGH THE SITE, SERVICES, OR APP.
        </p>
        <p>
          YOU MAY NOTIFY THE APP VENDOR IN THE EVENT OF ANY FAILURE OF THE APP TO CONFORM TO THE ABOVE-STATED WARRANTY.
          THE APP VENDOR WILL REFUND THE PURCHASE PRICE OF THE Casemasters APP TO YOU, BUT THE APP VENDOR WILL HAVE NO
          OTHER WARRANTY OBLIGATION WHATSOEVER WITH RESPECT TO THE Casemasters APP.
        </p>
        <p>
          NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED FROM Casemasters, INC. OR THROUGH THE SITE,
          SERVICES, APP, OR COLLECTIVE CONTENT, WILL CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN.
        </p>
        <p>
          YOU ARE SOLELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS AND INTERACTIONS WITH OTHER USERS OF THE SITE,
          SERVICES AND APP AND WITH OTHER PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT WITH AS A RESULT OF YOUR USE OF
          THE SITE, SERVICES, OR APP. YOU UNDERSTAND THAT Casemasters, INC. DOES NOT TAKE RESPONSIBILITY FOR SCREENING
          OR INQUIRY INTO THE BACKGROUND OF ANY USERS OF THE SITE, SERVICES, OR APP, NOR DOES Casemasters, INC. VERIFY
          OR TAKE RESPONSIBILITY FOR THE STATEMENTS OF USERS OF THE SITE, SERVICES, OR APP. Casemasters, INC. MAKES NO
          REPRESENTATIONS OR WARRANTIES AS TO THE CONDUCT OF USERS OF THE SITE, SERVICES, OR APP OR THEIR COMPATIBILITY
          WITH ANY CURRENT OR FUTURE USERS OF THE SITE, SERVICES, OR APP. YOU AGREE TO TAKE REASONABLE PRECAUTIONS IN
          ALL COMMUNICATIONS AND INTERACTIONS WITH OTHER USERS OF THE SITE, SERVICES AND APP AND WITH OTHER PERSONS WITH
          WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE OF THE SITE, SERVICES, OR APP, PARTICULARLY IF YOU
          DECIDE TO MEET OFFLINE OR IN PERSON.
        </p>
        <h2>13. INDEMNITY</h2>
        <p>
          You agree to defend, indemnify, and hold Casemasters, Inc., its officers, directors, employees and agents,
          harmless from and against any claims, liabilities, damages, losses, and expenses, proceedings or demands
          including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected
          with your access to or use of the Site, Services, App, or Collective Content, or your violation of these
          Terms.
        </p>
        <h2>14. LIMITATION OF LIABILITY</h2>
        <p>
          YOU ACKNOWLEDGE AND AGREE THAT, TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE ENTIRE RISK ARISING OUT OF YOUR
          ACCESS TO AND USE OF THE SITE, SERVICES, APP, AND COLLECTIVE CONTENT REMAINS WITH YOU. NEITHER Casemasters,
          INC. NOR ANY OTHER PERSON OR ENTITY INVOLVED IN CREATING, PRODUCING, OR DELIVERING THE SITE, SERVICES, APP, OR
          COLLECTIVE CONTENT WILL BE LIABLE FOR ANY INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES, INCLUDING
          LOST PROFITS, LOSS OF DATA, OR LOSS OF GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR
          THE COST OF SUBSTITUTE PRODUCTS OR SERVICES, OR FOR ANY DAMAGES FOR PERSONAL OR BODILY INJURY OR EMOTIONAL
          DISTRESS ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO USE THE SITE,
          SERVICES, APP, OR COLLECTIVE CONTENT, OR FROM ANY COMMUNICATIONS, INTERACTIONS, OR MEETINGS WITH OTHER USERS
          OF THE SITE, SERVICES, OR APP OR OTHER PERSONS WITH WHOM YOU COMMUNICATE OR INTERACT AS A RESULT OF YOUR USE
          OF THE SITE, SERVICES, OR APP WHETHER BASED ON WARRANTY, CONTRACT, DELICT, TORT (INCLUDING NEGLIGENCE),
          PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT Casemasters, INC. HAS BEEN INFORMED OF THE
          POSSIBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED IN MEETING ITS
          ESSENTIAL PURPOSE.
        </p>
        <p>
          IN NO EVENT WILL Casemasters, INC.’S AGGREGATE LIABILITY ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR
          FROM THE USE OF OR INABILITY TO USE THE SITE, SERVICES, APP, OR COLLECTIVE CONTENT EXCEED ONE HUNDRED DOLLARS
          ($100). THE LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF THE BARGAIN
          BETWEEN Casemasters, INC. AND YOU.
        </p>
        <h2>15. PROPRIETARY RIGHTS NOTICES</h2>
        <p>
          All trademarks, service marks, logos, trade names, and any other proprietary designations of Casemasters, Inc.
          used herein are trademarks or registered trademarks of Casemasters, Inc. Any other trademarks, service marks,
          logos, trade names and any other proprietary designations are the trademarks or registered trademarks of their
          respective parties.
        </p>
        <h2>16. APPLICABLE LAW; JURISDICTION</h2>
        <p>A. Law and Forum for Legal Disputes</p>
        <p>
          This Agreement or any claim, cause of action or dispute ("claim") arising out of or related to this Agreement
          shall be governed by the laws of the state of California regardless of your country of origin or where you
          access Doximity, and notwithstanding of any conflicts of law principles and the United Nations Convention for
          the International Sale of Goods. You and Doximity agree that all claims arising out of or related to this
          Agreement must be resolved exclusively by a state or federal court located in Santa Clara County, California,
          except as otherwise agreed by the parties or as described in the Arbitration Option paragraph below. You and
          Doximity agree to submit to the personal jurisdiction of the courts located within Santa Clara County,
          California for the purpose of litigating all such claims. Notwithstanding the above, you agree that Doximity
          shall still be allowed to apply for injunctive remedies (or an equivalent type of urgent legal relief) in any
          jurisdiction.
        </p>
        <p>B. Arbitration Option</p>
        <p>
          For any claim (excluding claims for injunctive or other equitable relief) where the total amount of the award
          sought is less than $10,000, the party requesting relief may elect to resolve the dispute in a cost effective
          manner through binding non-appearance-based arbitration. In the event a party elects arbitration, they shall
          initiate such arbitration through an established alternative dispute resolution ("ADR") provider mutually
          agreed upon by the parties. The ADR provider and the parties must comply with the following rules: (a) the
          arbitration shall be conducted by telephone, online and/or be solely based on written submissions, the
          specific manner shall be chosen by the party initiating the arbitration; (b) the arbitration shall not involve
          any personal appearance by the parties or witnesses unless otherwise mutually agreed by the parties; and any
          judgment on the award rendered by the arbitrator shall be final and may be entered in any court of competent
          jurisdiction.
        </p>
        <h2>17. ENTIRE AGREEMENT</h2>
        <p>
          These Terms together with all documentation and policies referenced herein constitute the entire and exclusive
          understanding and agreement between Casemasters, Inc. and you regarding the Site, Services, App and Collective
          Content, and these Terms supersede and replace any and all prior oral or written understandings or agreements
          between Casemasters, Inc. and you regarding the Site, Services, App, and Collective Content.
        </p>
        <h2>18. ASSIGNMENT</h2>
        <p>
          You may not assign or transfer these Terms, by operation of law or otherwise, without Casemasters, Inc.’s
          prior written consent. Any attempt by you to assign or transfer these Terms, without such consent, will be
          null and of no effect. Casemasters, Inc. may assign or transfer these Terms, at its sole discretion, without
          restriction. Subject to the foregoing, these Terms will bind and inure to the benefit of the parties, their
          successors and permitted assigns.
        </p>
        <h2>19. NOTICES</h2>
        <p>
          Any notices or other communications permitted or required hereunder, including those regarding modifications
          to these Terms, will be in a written form and given: (i) by Casemasters, Inc. via email (in each case to the
          address that you provide); or (ii) by posting to the Site; or (iii) via the App. For notices made by email,
          the date of receipt will be deemed the date on which such notice is transmitted.
        </p>
        <h2>20. DISPUTE RESOLUTION</h2>
        <p>
          Unless otherwise provided in the Country-Specific terms set out in Appendix A, all disputes between you and
          Casemasters arising out of or concerning these Terms, including but without limitation any dispute as to the
          interpretation of these Terms, any alleged breach of these Terms, the right of a party to exercise any right
          or remedy herein provided which have not been settled by informal negotiations or mediation, shall be resolved
          by binding arbitration in accordance with the Arbitrations Act, 1991 (Ontario) and the following provisions:
        </p>
        <ul>
          <li>
            <span>
              Post, upload, publish, submit, or transmit or otherwise make available any Content that you do not have a
              right to make available under any law or under contractual or fiduciary relationships;
            </span>
          </li>
          <li>
            <span>
              Take, post, upload, publish, transmit, or otherwise make use of any screen shots, screen captures,
              reproductions, drawings, photos, videos, downloads, or data of any of the images, comments, or
              contributions to Casemasters or any Collective Content;
            </span>
          </li>
          <li>
            <span>
              Post, upload, publish, submit or transmit any Content that: (i) infringes, misappropriates or violates a
              third party’s patent, copyright, trademark, trade secret, moral rights or other intellectual property
              rights, or rights of publicity or privacy; (ii) violates, or encourages any conduct that would violate,
              any applicable law or regulation or would give rise to civil liability; (iii) is fraudulent, false,
              misleading, or deceptive; (iv) is defamatory, obscene, pornographic, vulgar, or offensive; (v) promotes
              discrimination, bigotry, racism, hatred, harassment, or harm against any individual or group; (vi) is
              violent or threatening or promotes violence or actions that are threatening to any person or entity; or
              (vii) promotes illegal or harmful activities or substances;
            </span>
          </li>
          <li>
            <span>
              Use, display, mirror or frame the Site or App, or any individual element within the Site, Services or App,
              Casemasters, Inc. or Casemasters’s names, any Casemasters, Inc. trademark, logo, or other proprietary
              information, or the layout and design of any page or form contained on a page, without Casemasters, Inc.’s
              express written consent;
            </span>
          </li>
          <li>
            <span>
              Access, tamper with, or use non-public areas of the Site or App, Casemasters, Inc.’s computer systems, or
              the technical delivery systems of Casemasters, Inc.’s providers;
            </span>
          </li>
          <li>
            <span>
              Attempt to probe, scan, or test the vulnerability of any Casemasters, Inc. system or network or breach any
              security or authentication measures;
            </span>
          </li>
          <li>
            <span>
              Avoid, bypass, remove, deactivate, impair, descramble, or otherwise circumvent any technological measure
              implemented by Casemasters, Inc. or any of Casemasters, Inc.’s providers or any other third party
              (including another user) to protect the Site, Services, App, or Collective Content;
            </span>
          </li>
          <li>
            <span>
              Attempt to access or search the Site, Services, App, or Collective Content or download Collective Content
              from the Site, Services, or App through the use of any engine, software, tool, agent, device, or mechanism
              (including scripts, bots, spiders, scrapers, crawlers, data mining tools or the like) other than the
              software and/or search agents provided by Casemasters, Inc. or other generally available third party web
              browsers;
            </span>
          </li>
          <li>
            <span>
              Send any unsolicited or unauthorized advertising, promotional materials, email, junk mail, spam, chain
              letters, or other form of solicitation, from the App or otherwise;
            </span>
          </li>
          <li>
            <span>
              Use any meta tags or other hidden text or metadata utilizing a Casemasters, Inc. trademark, logo URL, or
              product name without Casemasters, Inc.’s express written consent;
            </span>
          </li>
          <li>
            <span>
              Use the Site, Services, App, or Collective Content for any commercial purpose or the benefit of any third
              party or in any manner not permitted by these Terms;
            </span>
          </li>
          <li>
            <span>
              Forge any TCP/IP packet header or any part of the header information in any email or newsgroup posting, or
              in any way use the Site, Services, App or Collective Content to send altered, deceptive, or false
              source-identifying information;
            </span>
          </li>
          <li>
            <span>
              Attempt to decipher, decompile, disassemble, or reverse engineer any of the software used to provide the
              Site, Services, App, or Collective Content;
            </span>
          </li>
          <li>
            <span>
              Interfere with, or attempt to interfere with, the access of any user, host or network, including, without
              limitation, sending a virus, overloading, flooding, spamming, or mail-bombing the Site, Services, or App;
            </span>
          </li>
          <li>
            <span>
              Collect or store any personally identifiable information from the Site, Services, or App from other users
              of the Site, Services, or App without their express permission;
            </span>
          </li>
          <li>
            <span>Impersonate or misrepresent your affiliation with any person or entity;</span>
          </li>
          <li>
            <span>Violate any applicable law or regulation, or any other rules of professional conduct; or</span>
          </li>
          <li>
            <span>Encourage or enable any other individual to do any of the foregoing.</span>
          </li>
        </ul>
        <h2>21. GENERAL</h2>
        <p>
          The failure of Casemasters, Inc. to enforce any right or provision of these Terms will not constitute a waiver
          of future enforcement of that right or provision. The waiver of any such right or provision will be effective
          only if in writing and signed by a duly authorized representative of Casemasters, Inc. Except as expressly set
          forth in these Terms, the exercise by either party of any of its remedies under these Terms will be without
          prejudice to its other remedies under these Terms or otherwise. If for any reason a court of competent
          jurisdiction finds any provision of these Terms invalid or unenforceable, that provision will be enforced to
          the maximum extent permissible and the other provisions of these Terms will remain in full force and effect.
        </p>
        <h2>22. MISCELLANEOUS</h2>
        <p>
          You acknowledge that the Terms apply to you and Casemasters, Inc. only, and not with any App Vendor. The App
          Vendor and any App Vendor subsidiaries are third party beneficiaries of the Terms. Upon your acceptance of the
          Terms, the App Vendor will have the right (and will be deemed to have accepted the right) to enforce the Terms
          against you as a third party beneficiary.
        </p>
        <p>
          You may not use or otherwise export or re-export the App except as authorized by both United States law and
          the laws of the jurisdiction in which you obtained Casemasters. In particular, but without limitation, the App
          may not be exported or re-exported (a) into any U.S.-embargoed countries or (b) to anyone on the U.S. Treasury
          Department's Specially Designated Nationals List or the U.S. Department of Commerce Denied Persons List or
          Entity List. By using the App, you represent and warrant that you are not located in any such country or on
          any such list. You also agree that you will not use these products for any purposes prohibited by United
          States law, including, without limitation, the development, design, manufacture, or production of nuclear,
          missile, or chemical or biological weapons.
        </p>
        <h2>23. CONTACTING Casemasters, INC.</h2>
        <p>
          If you have any questions about these Terms, please contact Casemasters, Inc., 75 E Santa Clara St, San Jose,
          CA 95113
        </p>
      </section>
    );
  }
}

export default TermsOfUse;



// WEBPACK FOOTER //
// ./src/scenes/Sections/TermsOfUse.js